/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useMemo } from 'react'
import { Button, Modal, ButtonToolbar } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import ReactLoading from 'react-loading'

import Toggle from './Toggle'

const ModalComponent = ({
  toggle,
  modal,
  handleSubmit,
  isError,
  handleRecipientCheckingNeededSubmit,
  isSubmitRecipientCheckingNeededSuccessfull,
  errorMessage,
  isSubmitSuccessful,
  isLoading,
  type,
  item,
  handleCuratorChangeAutopay,
  awaitingPayouts,
}) => {
  const { t } = useTranslation()

  const selectedPayout = useMemo(
    () =>
      awaitingPayouts && awaitingPayouts.find(payout => payout.id === item.id),
    [awaitingPayouts, item]
  )

  return (
    <div>
      <Modal
        fade={false}
        className={`modal-dialog--${
          type === 'payout' ? 'success' : 'danger'
        } modal-dialog--header modal-confirmation`}
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="text-modal  modal__title">
            {type === 'payout' ? 'Confirm Payment' : 'Confirmation'}
          </h4>
        </div>
        {!isLoading &&
          !isError &&
          !isSubmitSuccessful &&
          !isSubmitRecipientCheckingNeededSuccessfull && (
            <>
              <div className="modal__body">
                {item && item.Curator && type === 'payout' ? (
                  <div>
                    <p>{t('adminPage.confirmPaymentText')}</p>
                    <div className="modal-info__toggle-wrapper">
                      <div className="modal-info__toggle">
                        <Toggle
                          isChecked={
                            selectedPayout &&
                            selectedPayout.Curator &&
                            selectedPayout.Curator.autopay
                          }
                          onChange={() => {
                            handleCuratorChangeAutopay(
                              selectedPayout.Curator.user_id,
                              selectedPayout.Curator.autopay
                            )
                          }}
                        />
                      </div>

                      <span>{t('adminPage.confirmAutopay')}</span>
                    </div>
                  </div>
                ) : (
                  <p>
                    Are you sure you would like to block {item.first_name}
                    {item.last_name && ` ${item.last_name}`}? Awaiting payouts
                    and awaiting reviews should be cancelled.
                  </p>
                )}
              </div>

              <ButtonToolbar className="modal__footer">
                {type !== 'payout' && (
                  <Button className="modal_cancel" onClick={toggle}>
                    Cancel
                  </Button>
                )}
                <Button
                  className="modal_ok"
                  color={type === 'payout' ? 'success' : 'danger'}
                  onClick={
                    type === 'payout'
                      ? () => handleSubmit(item.curator_id, item.id)
                      : () => handleSubmit(item.id)
                  }
                >
                  {type === 'payout'
                    ? t('adminPage.confirmButton')
                    : t('adminPage.blockButton')}
                </Button>
              </ButtonToolbar>
            </>
          )}
        {isLoading && (
          <ReactLoading
            className="users-loading loading"
            height={24}
            type="spinningBubbles"
          />
        )}
        {isError && !isLoading && (
          <>
            <div className="modal__body">
              <p>
                <b>{errorMessage}</b>
              </p>
              <p>
                Notify Recipient ({item.Curator.first_name}
                {item.Curator.last_name && ` ${item.Curator.last_name}`}) to
                have it checked or changed payment information.
              </p>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button className="modal_cancel" onClick={toggle}>
                Cancel
              </Button>
              <Button
                className="modal_ok"
                color="success"
                onClick={() =>
                  handleRecipientCheckingNeededSubmit(item.curator_id, item.id)
                }
              >
                Notify Recipient
              </Button>
            </ButtonToolbar>
          </>
        )}
        {isSubmitSuccessful && (
          <div className="modal__body">
            {type === 'payout' ? (
              <p>Payment submitted successfully for this account.</p>
            ) : (
              <p>The account is blocked successfully.</p>
            )}
          </div>
        )}
        {isSubmitRecipientCheckingNeededSuccessfull && (
          <div className="modal__body">
            <p>Recipient will get notification and email soon.</p>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default ModalComponent
